import React, { useRef } from 'react';

const DemoSearch = ({ setFilter }) => {
  const inputRef = useRef();

  function handleSearch() {
    setFilter(inputRef.current.value);
  }

  return (
    <div className="demoSearch">
      <input ref={inputRef} className="demoSearchInput" type="text" placeholder="Search tweets" />
      <button className="demoSubmit" type="submit" onClick={handleSearch}>
        Search
      </button>
    </div>
  );
};

export default DemoSearch;